import { render, staticRenderFns } from "./VBottomSheet.vue?vue&type=template&id=2cf2faa1&scoped=true&"
import script from "./VBottomSheet.vue?vue&type=script&lang=js&"
export * from "./VBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./VBottomSheet.vue?vue&type=style&index=0&id=2cf2faa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2faa1",
  null
  
)

export default component.exports